import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const getPageTitle = (pathname) => {
  const titles = {
    '/': 'Dashboard',
    '/logs/new': 'New Production Log',
    '/logs': 'Production Logs',
    '/analytics/rates': 'Production Rates',
    '/analytics/estimator': 'Job Estimator',
    '/analytics/formwork': 'Formwork Efficiency',
    '/analytics/equipment': 'Equipment Utilization',
    '/projects': 'Projects'
  };
  
  return titles[pathname] || 'Baby Blue Concrete';
};

const Layout = () => {
  const location = useLocation();
  const title = getPageTitle(location.pathname);

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <Header title={title} />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;